import React from 'react'
import TabTitleH2 from '../../titles/TabTitleH2'
import CategoryBox from './categoryBox/CategoryBox'

const CategoryBoxes = () => {
  
  const random = () => Math.ceil(Math.random()*70)+100

  return (<>
    <div className='d-flex w-100 flex-wrap justify-content-center'>
      <TabTitleH2>Inventory</TabTitleH2>
      {[0,1,2,3,4,5,6].map(x => <CategoryBox key={x} quantity={random()} id={x} />)}
    </div>
  </>)
}

export default CategoryBoxes